import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import Common from "us.common";
import { templateEditor } from "reducers/TemplateEditor";
import { deliveryStatusDashboard } from "reducers/DeliveryStatusDashboard";
import { templatesHistory } from "reducers/TemplatesHistory";
import { editorHome } from "reducers/EditorHome";
import { textEditor } from "reducers/TextEditor";
const reducers = {
  ...Common.Reducers,
  deliveryStatusDashboard,
  templateEditor,
  templatesHistory,
  editorHome,
  textEditor,
};

const rootReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    ...reducers,
  });

export default rootReducer;
